"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_BALANCE_FRAGMENT = void 0;
const client_1 = require("@apollo/client");
exports.GET_BALANCE_FRAGMENT = client_1.gql `
  fragment balanceFragment on Guest {
    id
    balanceInformation {
      guestAvailableBalance {
        amount
        currency
      }
      guestAllowedBalance {
        amount
        currency
      }
    }
  }
`;
